import { NgIf } from '@angular/common';
import { computed, DestroyRef, Directive, inject, input } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { filter, switchMap, tap } from 'rxjs';
import { Entitlement, EntitlementMode } from './entitlement.model';
import { EntitlementService } from './entitlement.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ifEntitlements]',
  standalone: true,
  hostDirectives: [
    {
      directive: NgIf,
      inputs: ['ngIfThen: ifEntitlementsThen', 'ngIfElse: ifEntitlementsElse'],
    },
  ],
})
export class IfEntitlementsDirective {
  constructor() {
    toObservable(this.requirements)
      .pipe(
        filter(({ keys }) => isNotNullish(keys)),
        switchMap(({ keys, mode }) => this.entitlementService.select(keys, mode)),
        tap((hasAccess) => {
          this.ngIfDirective.ngIf = hasAccess;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  private readonly ngIfDirective = inject(NgIf<boolean>, { host: true });
  private readonly entitlementService = inject(EntitlementService);
  private readonly destroyRef = inject(DestroyRef);

  readonly ifEntitlements = input<Entitlement | Entitlement[] | null>(null);
  readonly ifEntitlementsMode = input<EntitlementMode>('all');

  private readonly requirements = computed(() => ({
    keys: this.ifEntitlements(),
    mode: this.ifEntitlementsMode(),
  }));
}
